import Vue from 'vue'
//import axios from '../../global/axios.js'
//import { INTERFACE } from "../../assets/interface/base.js";
//import { STATUSCODE } from '../../assets/js/defined.js';
//import { Message } from 'element-ui';
export default {
	state: {
		//switch样式
		switchStyle: ["#13ce66", "#ff4949"],
		// 认证状态1未认证2认证中3认证通过4认证未通过
		authStatusList: [{
			name:'未认证',
			code: 1
		},{
			name:'认证中',
			code: 2
		},{
			name:'认证通过',
			code: 3
		},{
			name:'认证未通过',
			code: 4
		}],
		//默认分页当前显示条数
		pageRow: 20,
		currentPage: 1,
		//token
		token: '',
		xsrfToken:'',
		setPwdShow: false,
		userInfo: {},
		//所有权限
		showButtonList: [],
		tableHeight: 0,
		ymtHeader:false,
	},
	mutations: {
		setToken(state, token) {
			state.token = token;
			Vue.localStrage.set('token', token);
		},
		setXsrfToken(state, token) {
			state.xsrfToken = token;
			Vue.localStrage.set('xsrfToken', token);
		},
		//计算表格固定高度
		setTableHeight(state) {
			setTimeout(function (){
				let searchDom = document.querySelector(".yl-search");
				let titleDom = document.querySelector(".yl-title");
				let pageDom = document.querySelector(".el-pagination");
				let tableHeaderDom = document.querySelector(".el-table__header");
				let searchDomHeight = searchDom ? searchDom.clientHeight : 0;
				let titleDomHeight = titleDom ? titleDom.clientHeight : 0;
				let pageDomHeight = pageDom ? pageDom.clientHeight : 32; //有时无法获取
				let tableHeaderDomHeight = tableHeaderDom ? tableHeaderDom.clientHeight : 0;
				if (titleDom) {
					state.tableHeight = window.innerHeight - searchDomHeight - titleDomHeight - pageDomHeight - tableHeaderDomHeight + 25;
				}

			}, 300);
		},
		// pc端显示ymtHeader
		setYmtHeader(state){
			state.ymtHeader = true;
		},
	},
	getters: {
		getToken: state => {
			return state.token || sessionStorage.getItem("zqyl-token") || localStorage.getItem("token");
		},
		getXsrfToken:state => {
			return state.xsrfToken || Vue.localStrage.get("xsrfToken");
		},
		getUserInfo: state => {
			return JSON.stringify(state.userInfo) != "{}" ? state.userInfo : JSON.parse(Vue.localStrage.get("userInfo"));
		},
		getPublicStatus: state => (code, obj) => {
			let data = state[obj].find(item => item.code == code);
			return data ? data.name : "";
		},
	},
	actions: {
		
	}
}